import { ICartProduct } from './cart-product';

export enum CartActionKind {
	ADD_TO_CART = 'ADD_TO_CART',
	REMOVE_FROM_CART = 'REMOVE_FROM_CART',
	INCREMENT = 'INCREMENT',
	DECREMENT = 'DECREMENT',
	CLEAR= 'CLEAR',
	TOTAL = 'TOTAL'
}

export interface ICartAction {
	type: CartActionKind;
	payload: ICartProduct
}
